import React, { useMemo } from "react";

import { Table } from "semantic-ui-react";

import Icon from "@cayuse/shared-react.components.icon";

import { useTenantFormatter } from "components/BudgetBuilder/shared/TenantFormatter";

import styles from "./styles.css";

const formatPercent = percent => percent ? `${percent.toFixed(2)}%` : "--";

export const RateTypeRow = ({ row, rateOrder }) => {
	const { dateFormatter } = useTenantFormatter();
	const sortedRates = useMemo(
		() => row?.rates?.sort((c, p) => rateOrder[c?.categoryId] - rateOrder[p?.categoryId]),
		[ rateOrder, row.rates ]
	);

	return (
		<Table.Row>
			<Table.Cell>
				<div className={styles.dateRangeWrapper}>
					<div className={styles.dateWrapper}>
						<Icon
							name="calendar"
							size="bigger"
						/>
						{dateFormatter(row?.startDate) || "--"}
					</div>
					<div className={styles.dateToWrapper}>
						<div className={styles.dateToDivider}/>
					</div>
					<div className={styles.dateWrapper}>
						<Icon
							name="calendar"
							size="bigger"
						/>
						{dateFormatter(row?.endDate) || "--"}
					</div>
				</div>
			</Table.Cell>
			{sortedRates?.map((rate, index) => (
				<Table.Cell key={index}>{formatPercent(rate?.percent)}</Table.Cell>
			))}
		</Table.Row>
	);
};
